module.exports = __webpack_public_path__ + "static/media/FM__ASIC__TradingView_Promotion_May_2024.63f335ed.pdf";